import { render, staticRenderFns } from "./vsSidebarItem.vue?vue&type=template&id=74ad8ff9&"
import script from "./vsSidebarItem.vue?vue&type=script&lang=js&"
export * from "./vsSidebarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsSidebarItem.vue"
export default component.exports